exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fade-enter-active[data-v-d7a11fbc],.fade-leave-active[data-v-d7a11fbc]{-webkit-transition:opacity .5s;transition:opacity .5s}.fade-enter[data-v-d7a11fbc],.fade-leave-to[data-v-d7a11fbc]{opacity:0}", ""]);

// exports
